var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SportModel } from "../../../model";
export class PersonalizedBaseRetriever {
    constructor(
    // connections: ConnectionMap,
    gateway, dict, refreshInterval, sportsMapper, enableForYouTab, maxNumberOfSports, maxNumberOfEventsPerSport, regionId) {
        this.forYouTabIdSeparator = ",";
        // this.connections = connections
        this.gateway = gateway;
        this.dict = dict;
        this.refreshInterval = refreshInterval;
        this.isActive = false;
        this.sportsMapper = sportsMapper;
        this.enableForYouTab = enableForYouTab;
        this.maxNumberOfSports = maxNumberOfSports;
        this.maxNumberOfEventsPerSport = maxNumberOfEventsPerSport;
        this.regionId = regionId;
        this.personalizedRefreshTimer = -1;
    }
    activate() {
        this.isActive = true;
    }
    deactivate() {
        this.isActive = false;
        window.clearTimeout(this.personalizedRefreshTimer);
    }
    refresh(state, requestFactory) {
        return __awaiter(this, void 0, void 0, function* () {
            window.clearTimeout(this.personalizedRefreshTimer);
            return this.refreshInternal(state, requestFactory);
        });
    }
    refreshInternal(state, requestFactory) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getPersonalizedSports(requestFactory);
            if (this.isActive && response) {
                this.setSports(state, response);
                if (this.refreshInterval > 0) {
                    this.personalizedRefreshTimer = window.setTimeout(() => this.refreshInternal(state, requestFactory), this.refreshInterval);
                }
            }
        });
    }
    // Promise<PersonalizedSport[]>
    getPersonalizedSports(queryProvider) {
        return __awaiter(this, void 0, void 0, function* () {
            // const connection = this.connections.filterPersonalizedSports()
            // console["log"](connection)
            // const request = queryProvider(
            //     this.maxNumberOfSports,
            //     this.maxNumberOfEventsPerSport,
            //     this.regionId
            // )
            // return await new Promise<PersonalizedSportsResponse>(
            //     (resolve, reject) => {
            //         connection.loadData(request, resolve)
            //     }
            // )
            try {
                return yield this.gateway.getPersonalizedPreLiveSports(queryProvider(this.maxNumberOfSports, this.maxNumberOfEventsPerSport, this.regionId));
            }
            catch (_a) {
                return [];
            }
        });
    }
    setSports(state, sports) {
        if (sports && sports.length > 0) {
            const newSports = this.sportsMapper.map(sports);
            state.replaceItems(this.getPersonalizedItems(newSports));
        }
    }
    getPersonalizedItems(sports) {
        if (!this.enableForYouTab) {
            return sports;
        }
        const forYouData = this.getForYouTabData(sports);
        return [new SportModel(forYouData, "personalized"), ...sports];
    }
    getForYouTabData(sports) {
        const numberOfSportsEvents = sports.reduce(this.sportsMaxEventsReducer, 0);
        const forYouTabId = sports.map(s => s.id).join(this.forYouTabIdSeparator);
        return {
            name: this.dict.forYou,
            id: forYouTabId,
            order: 0,
            numberOfEvents: Math.min(this.maxNumberOfEventsPerSport, numberOfSportsEvents)
        };
    }
    sportsMaxEventsReducer(currNumberOfEvents, currSport) {
        return currNumberOfEvents + currSport.numberOfEvents;
    }
}
//# sourceMappingURL=PersonalizedBaseRetriever.js.map